export default __webpack_public_path__ + "models/f8c9da2b45468eee76eea1efc9bdf9b3.glb";